import { Tag } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const RESULT_TAGS = {
    processing: { color: 'processing', icon: <LoadingOutlined aria-hidden="true" /> },
    success: { color: 'success', icon: <i className="fi fi-rr-check" aria-hidden="true" /> },
    failed: { color: 'error', icon: <i className="fi fi-rr-cross-small" aria-hidden="true" /> },
};

/** A batch's result: Processing (blue, spinning), Success ✓, Failed ✕; a result the API could not map → Unknown. */
const BatchResultTag = ({ result }) => {
    const { t } = useTranslation('vinExtraction');
    const tag = RESULT_TAGS[result];

    return (
        <Tag color={tag?.color ?? 'default'} icon={tag?.icon} bordered={false}>
            {t(`batches.result.${tag ? result : 'unknown'}`)}
        </Tag>
    );
};

export default BatchResultTag;
